/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useRef } from "react";
import QuantityEditable from "./QuantityEditable";
import PaymentPopup from "./PaymentPopup";
import Context from "../context/context";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import { ShoppingBagIcon, PencilAltIcon, ChevronUpIcon, } from "@heroicons/react/solid";
import FBRunningOrder from "../firebase/running_order_firebase";

import { openDB } from "idb";
import { ArrowDropDown, SquareFoot } from '@mui/icons-material';
import { MultiSelectDropDown } from "./CustomDropDown";
import OrderSummaryTable from "./OrderSummaryTable"
import BrandSelectionPopUp from "../containers/BrandSelectionPopUp";
import axios from "axios";

let brand_orders = [];
const Info = ({
  runningOrder, setRunningOrder,
  orderProps, setOrderProps,
  isPaymentOptionOpen, setPaymentOptionOpen
}) => {

  const Navigate = useNavigate();
  const { order_type, order_uuid, order_uuids, seat_uuid, refreshDashboard } = orderProps
  const context = useContext(Context);
  const page = "/" + window.location.pathname.split('/').filter(i => i)[0];
  const [itemCharges, setItemCharges] = useState({ data: null });

  // Import content from context.
  const {
    cartHandler,
    menusCollection,
    applyChargesDiscounts,
    setForceRenderOrdersPage,
    itemChargesHandlerRef,
    itemChargesValueRef,
    updateOrderCustomer,
    updateCustomerData,
    updateUnSync,
    new_order,
    new_kotOrder,
    PrintInvoice, PrintKotInvoice, currentOrderRef,
    seatsState, sectionsState, showWarning: warn
  } = context;

  const [customerInfo, setCustomerInfo] = useState({ name: '', number: '' })
  const [isKOTPopupActive, setIsKOTPopupActive] = useState(false);
  const [isInvoiceActive, setIsInvoiceActive] = useState(false);
  const [isChefPopupActive, setIsChefPopupActive] = useState(false);
  const [isDirectAddPopupActive, setIsDirectAddPopupActive] = useState(false);
  const [isChargePopupActive, setIsChargePopupActive] = useState(false);
  const [isDiscountPopupActive, setIsDiscountPopupActive] = useState(false);

  const [totalAmount, setTotalAmount] = useState(0);
  const [page2Total, setPage2Total] = useState(0);
  const [domState, setDomState] = useState("");
  const [itemsList, setItemsList] = useState(null);
  const [customersDetails, setCustomersDetails] = useState([])
  const [orderRemarks, setOrderRemarks] = useState("")
  const cursorOverSuggestionRef = useRef(null);

  const [printDependencies, setPrintDependencies] = useState({})

  // load printDependencies & itemsList
  useEffect(() => {
    let abortController = new AbortController();
    const loadData = async () => {
      let indexedDB = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = indexedDB.transaction("outlet", "readonly").objectStore("outlet");

      const outlet = await tx.get(localStorage.getItem('outlet_uuid'))
      const dateFormat = await outlet?.setup?.date_format
      const invoice_setup = await outlet.invoice_setup
      const kot_setup = await outlet.kot_setup
      const section_details = await outlet?.section_details

      tx = indexedDB.transaction("item_grouping", "readonly").objectStore("item_grouping");
      const item_groups = await tx.getAll();

      tx = indexedDB.transaction("item", "readonly").objectStore("item");
      const items = await tx.getAll();

      tx = indexedDB.transaction("category", "readonly").objectStore("category");
      const categoryDetails = await tx.getAll();

      tx = indexedDB.transaction("payment_modes", "readonly").objectStore("payment_modes");
      const paymentMode = await tx.getAll();

      tx = indexedDB.transaction("seats", "readonly").objectStore("seats");
      const seats = await tx.getAll();

      tx = indexedDB.transaction("user", "readonly").objectStore("user");
      const user = tx.getAll();

      setItemsList(items)
      setPrintDependencies({
        dateFormat,
        invoice_setup,
        kot_setup,
        item_groups,
        items,
        categoryDetails,
        paymentMode,
        section_details,
        seats,
        user
      })
    }
    loadData()
    return () => {
      abortController.abort()
    }
  }, [])

  // order json fetch and store into state
  useEffect(() => {
    if (!order_type || !order_uuids) return;

    const fetchUnplacedOrder = async localCollection => {
      const unplaced_order_items = await (await JSON.parse(localStorage.getItem(localCollection)))?.find(i => i.order_uuid === order_uuid)
      if (unplaced_order_items) return unplaced_order_items.items
      else return null
    }

    const loadOrderDetails = async () => {
      let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      let tx = db.transaction("running_orders", "readonly").objectStore("running_orders");

      let orderDocs = [];
      for (let i = 0; i < order_uuids?.length; i++) {
        let orderDoc = await tx.get(order_uuids[i])
        orderDoc && orderDocs.push(orderDoc)
      }

      let order;
      // console.log(orderDocs)
      // return
      if (!orderDocs?.[0]) {
        let orderDoc = await (await JSON.parse(localStorage.getItem("meal_orders")))?.find(o => o.order_uuid === order_uuid)
        orderDoc && orderDocs.push(orderDoc)
      }
      if (orderDocs?.[0]) {

        brand_orders = orderDocs?.map(({ order_uuid, brand_uuid }) => ({ order_uuid, brand_uuid }))
        order = orderDocs[0];
        currentOrderRef.current = orderDocs[0]
        // console.log(orderDocs)

        const amount = await orderDocs?.reduce((sum, order) => sum + +order.order_total, 0)
        setCustomerInfo({ name: order?.customer_name, number: order?.customer_mobile })
        setCustomerAddress(order?.delivery_address)
        setTotalAmount(amount);
        setPage2Total(amount);
        setRunningOrder(orderDocs)
        if (orderDocs[0]?.remarks) setOrderRemarks(orderDocs[0]?.remarks)

        if (page === '/page2') {
          const unplaced_order_items = await fetchUnplacedOrder(+order_type === 0 ? 'unplaced_orders' : 'extended-nonseat-order')
          if (unplaced_order_items) {
            setItemCharges({ data: unplaced_order_items });
          }
        }
      }
      else {
        const unplaced_order_items = await fetchUnplacedOrder(+order_type === 0 ? 'unplaced_orders' : 'unplaced-nonseat-order');

        if (page === '/page2' && unplaced_order_items) {
          setItemCharges({ data: [...unplaced_order_items] });
        }
        else {
          console.log('No order found');
          itemChargesValueRef.current = []
          if (itemCharges?.data) setItemCharges({ data: [] });
          if (customerAddress) setCustomerAddress('');
          if (totalAmount) setTotalAmount(0);
          if (page2Total) setPage2Total(0);
          if (totalAmount) setTotalAmount(0);
          currentOrderRef.current = null
        }
        setRunningOrder([]);
        if (customerInfo?.number || customerInfo?.name) setCustomerInfo({ name: '', number: '' });
      }
    };

    loadOrderDetails()

    return () => {
      brand_orders = []
      setRunningOrder([])
    }
  }, [order_type, order_uuids])

  // Set selected items price in state and store items in localStorage --for page 2--
  useEffect(() => {
    if (!page.includes("/page2") || sessionStorage.getItem('is-payment-popup') === "true" || !order_uuid || !order_type) return;
    if (!itemCharges?.data) return null;

    const brands = itemCharges?.data?.reduce((brands, item) => !brands.includes(item.brand_uuid) ? [...brands, item.brand_uuid] : brands, [])

    let valid_ids = brand_orders?.filter(i => brands?.includes(i.brand_uuid));
    let new_brands = brands?.filter(brand_uuid => !brand_orders?.find(j => j.brand_uuid === brand_uuid))
    if (new_brands?.[0]) {
      valid_ids = valid_ids?.concat?.(new_brands?.map(brand_uuid => ({ brand_uuid, order_uuid: uuidv4() })))
    }
    brand_orders = [...valid_ids];

    itemChargesValueRef.current = itemCharges?.data || [];
    let amount = 0;
    if (itemCharges?.data?.length > 0) itemCharges.data?.forEach((element) => amount += +element.order_item_amount_inclusive_taxes);

    amount = +(amount.toFixed(Number(sessionStorage.getItem("decimal_length"))));
    setTotalAmount(amount);

    if (+order_type === 0) {

      const seat_order = JSON.parse(localStorage.getItem("onorder_seats"))?.find(order => order.seat_uuid === seat_uuid);

      let amountPage2 = Number(seat_order ? seat_order.price : 0) + Number(amount);
      setPage2Total(amountPage2);

      // Store selected items in localStorage on item selection.
      let unplacedOrders = JSON.parse(localStorage.getItem("unplaced_orders")) || [];
      let unplacedOrder = unplacedOrders?.find(order => order.seat === seat_uuid);

      if (unplacedOrder) {
        let filtered_orders = unplacedOrders.filter(order => order.seat !== seat_uuid);
        unplacedOrder.items = itemCharges?.data;
        filtered_orders.push(unplacedOrder);
        localStorage.setItem("unplaced_orders", JSON.stringify(filtered_orders));
      } else {
        unplacedOrders.push({
          seat: sessionStorage.getItem("seat"),
          items: itemCharges?.data,
          order_uuid: order_uuid
        });
        localStorage.setItem("unplaced_orders", JSON.stringify(unplacedOrders));
      }

      // Clear selected items object in local storage when all items've been removed from state
      let unplaced_orders = JSON.parse(localStorage.getItem("unplaced_orders")) || [];
      localStorage.setItem("unplaced_orders", JSON.stringify(unplaced_orders.filter(i => i.items?.length > 0)));
    } else {

      setPage2Total(amount);
      let collectionName = "unplaced-nonseat-order";
      if (runningOrder?.[0]) collectionName = "extended-nonseat-order"
      let collection = JSON.parse(localStorage.getItem(collectionName)) || [];
      let orderDoc = collection?.find(i => i.order_uuid === order_uuid);

      if (!orderDoc) {
        localStorage.setItem(collectionName, JSON.stringify([...collection, {
          created_at: Date.now(),
          order_uuid: order_uuid,
          items: itemCharges.data,
          placed: runningOrder?.[0] ? true : false,
          order_type,
          amount
        }]))
      } else {
        collection = collection?.filter(i => i.order_uuid !== order_uuid);
        if (itemCharges?.data?.length > 0)
          collection.push({
            ...orderDoc,
            items: itemCharges.data,
            amount
          });
        localStorage.setItem(collectionName, JSON.stringify(collection));
      }
    }
  }, [itemCharges, order_uuid, order_type]);

  const grabIDBCustomersData = () => {

    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.addEventListener("error", (err) => { console.warn(err); });
    DBOpenReq.addEventListener("success", (ev) => {

      let store = ev.target.result.transaction("customer", "readonly").objectStore("customer");

      const getCustomers = store.getAll();
      getCustomers.onsuccess = customersEvent => {

        let data = customersEvent.target.result;
        const customers_details = [];

        data.forEach(c => {
          const outlet_detail = c?.outlet_wise_customer_details
            ?.find(o => o.outlet_uuid === localStorage.getItem("outlet_uuid"));

          customers_details.push({
            id: uuidv4(),
            address: outlet_detail?.customer_outlet_address || "",
            visits: outlet_detail?.customer_visits,
            mobile: c.customer_mobile,
            name: outlet_detail?.name || ""
          })

          if (data.length === customers_details?.length)
            setCustomersDetails(customers_details)
        })
      }
    })
  }

  useEffect(grabIDBCustomersData, [])

  const handleMenuAddUnsyncedFiles = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
    const ndata = {
      invoice_series: data,
      RECON_TIME: `${Date.now()}`,
      IDENTIFIER: "invoice_series:" + data.series,
    };
    await tx.put(ndata);
    handleMenuReconciliation(ndata);
    updateUnSync()
  };

  // Adding/Editing menu to reconciliation collection in IndexedDB
  const handleMenuReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db.transaction("reconciliation", "readwrite").objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const menusJsonExists = allReconRecords.find((curr) => curr.IDENTIFIER === "invoice_series");
    if (menusJsonExists) {
      const menus = menusJsonExists?.details?.filter((menu) => menu.user_uuid !== data.invoice_series.user_uuid)
      const editData = {
        ...menusJsonExists,
        details: [
          ...menus,
          {
            user_uuid: data.invoice_series.user_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData)

    } else {
      const newdata = {
        IDENTIFIER: "invoice_series",
        details: [
          {
            user_uuid: data.invoice_series.user_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ]
      };
      await tx.add(newdata);
    }
  }

  // Customer data handlers
  // Fill selected contact details automatically in target input fields
  const storeOrdersContacts = (value, field_code) => {
    runningOrder?.forEach(({ order_uuid }) => {
      const customers = JSON.parse(localStorage.getItem("customers-orders-info")) || {};
      customers[order_uuid] = customers[order_uuid] || {};
      if (field_code === 1) customers[order_uuid].customer_mobile = value
      else if ((field_code === 2)) customers[order_uuid].customer_name = value
      localStorage.setItem("customers-orders-info", JSON.stringify(customers))
    })
  }

  const storeCustomersData = (value, field_code) => {
    if (!value.id) return;
    runningOrder?.forEach(({ order_uuid }) => {
      const customers = JSON.parse(localStorage.getItem("customers-data")) || {};
      customers[value.id] = customers[value.id] || {};
      if (field_code === 1) customers[value.id].customer_outlet_address = value.address;
      if (!customers[value.id].uuid && order_uuid) customers[value.id].uuid = order_uuid;
      localStorage.setItem("customers-data", JSON.stringify(customers))
    })
  }

  // Update user contact details into the indexeddb. (CALLED WHEN a user leave input field -> onBlur())
  const updateContact = () => {
    const info = JSON.parse(sessionStorage.getItem('customer-updated-info'));
    let DBOpenReq = indexedDB.open("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    DBOpenReq.addEventListener("error", err => console.warn(err));
    DBOpenReq.addEventListener("success", (ev) => {
      let db = ev.target.result;
      let tx = db.transaction("running_orders", "readwrite");
      let store = tx.objectStore("running_orders");
      let getOrderReq = store.get(order_uuid);

      getOrderReq.onsuccess = (ev) => {
        let order = ev.target.result;
        order.IsSynched = 0;
        order.customer_mobile = info.number;
        order.customer_name = info.name;
        store.put(order);
      };
      setTimeout(() => document.getElementById("suggestions-div").style.display = "none", 300);
    });
  };

  function details_fill_handler(e) {

    let name = e.target.parentNode.querySelector('[name="customer_name"]').innerText;
    let number = e.target.parentNode.querySelector('[name="customer_mobile"]').innerText;

    if (!number.includes("+91-"))
      number = "+91-" + number;

    storeOrdersContacts(number, 1);
    storeOrdersContacts(name, 2);

    setCustomerInfo({ name: name, number: number });
    sessionStorage.setItem('customer-updated-info', JSON.stringify({
      name: name,
      number: number,
      order_uuid
    }))

    document.getElementById("suggestions-div").style.display = "none";
    cursorOverSuggestionRef.current = null;

    setTimeout(() => {
      updateOrderCustomer()
    }, 1000);
  }

  // Show available contact suggestions from customer json.
  function showSuggestions(e) {

    const input = e.target.value.toLowerCase();
    const container = document.getElementById("suggestions-div");
    const detailsArray = JSON.parse(sessionStorage.getItem("customer_details")) || [];

    if (input.length > 2 && detailsArray) {
      const id = e.target.id;
      if (id.includes("name")) container.style.justifyContent = "flex-end";
      else container.style.justifyContent = "flex-start";
      container.style.display = "flex";

      let labelsHTML = (
        <div
          onMouseEnter={e => cursorOverSuggestionRef.current = "visible"}
          onMouseLeave={e => cursorOverSuggestionRef.current = null}
        >
          {detailsArray?.map((customer) => {
            if (
              customer.customer_mobile &&
              customer.customer_name
            )
              if (
                customer.customer_mobile.includes(input) ||
                customer.customer_name.includes(input)
              ) {
                if (id.includes("number"))
                  return (
                    <label
                      key={Math.random()}
                      className="contact-suggestion"
                      onClick={(e) => details_fill_handler(e)}
                    >
                      <div className="bold" name="customer_mobile">
                        {customer.customer_mobile}
                      </div>
                      <div className="light" name="customer_name">
                        {customer.customer_name}
                      </div>
                    </label>
                  );
                else if (id.includes("name"))
                  return (
                    <label
                      key={Math.random()}
                      className="contact-suggestion"
                      onClick={(e) => details_fill_handler(e)}
                    >
                      <div className="bold" name="customer_name">
                        {customer.customer_name}
                      </div>
                      <div className="light" name="customer_mobile">
                        {customer.customer_mobile}
                      </div>
                    </label>
                  );
                else return ''
              }
              else return ''
            else return ''
          })}
        </div>
      );
      setDomState(labelsHTML);
    } else container.style.display = "none";
  }

  // * Print Functions
  const printKotInvoice = async (kotNumber, order_json, callback = () => setIsKOTPopupActive(false)) => {

    if (!order_json) return console.log('No order found to print for given order_uuid: ', order_uuid)
    const seat = await order_json?.seat_uuid ? printDependencies?.seats?.find(i => i.seat_uuid === order_json.seat_uuid) : ''
    const section = await order_json?.seat_uuid ? printDependencies?.section_details?.find(i => i.section_uuid === seat?.section_uuid) : ''

    PrintKotInvoice({
      dependencies: {
        user_title: printDependencies?.users?.find(i => i.user_uuid === order_json.payment_by_user_uuid),
        order_json,
        paymentMode: printDependencies?.paymentMode,
        categoryDetails: printDependencies?.categoryDetails,
        kot_setup: printDependencies?.kot_setup,
        kotNumber,
        section_name: section?.section_name,
        seat_name: seat?.seat_name,
        itemsDetails: printDependencies?.items,
        dateFormat: printDependencies?.dateFormat,
      },
      item_groups: printDependencies?.item_groups,
      callback
    })
  };

  const invoicePrintLoop = async (num, ebill, debug_print, orders = runningOrder) => {

    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let printedOrders = []

    const print = async order_uuid => {

      if (!order_uuid) return setIsInvoiceActive(false)

      printedOrders = [...printedOrders, order_uuid]
      let order_json = await orders?.find(i => i.order_uuid === order_uuid)
      const printParams = { num, ebill, debug_print, order_json }

      const callback = async () => {

        let object = {
          at: Date.now(),
          copies: num,
          user_uuid: localStorage.getItem("user_uuid"),
        };

        order_json.invoice_prints = order_json.invoice_prints || [];
        order_json.invoice_prints.push(object);
        order_json.IsSynched = 0;

        await db.transaction("running_orders", "readwrite").objectStore("running_orders").put(order_json);
        print(brand_orders?.map(i => i.order_uuid)?.filter(i => !printedOrders?.includes(i))?.[0])

        if (!order_json.seat_uuid) return;
        let onseat_orders = JSON.parse(localStorage.getItem("onorder_seats"));
        onseat_orders = onseat_orders.filter(i => i.seat_uuid !== order_json.seat_uuid)
        onseat_orders.push({
          seat_uuid: order_json.seat_uuid,
          created_at: order_json.created_at,
          price: order_json.order_total,
          title: order_json.local_order_id,
          uuid: order_json.order_uuid,
          invoiced: 1
        });
        localStorage.setItem("onorder_seats", JSON.stringify(onseat_orders));
      }

      await handleInvoicePrint({
        callback,
        browser_print: true,
        ...printParams,
      })
    }
    print(brand_orders?.map(i => i.order_uuid)?.[0])
  }

  const handleInvoicePrint = async params => {

    const { num, ebill, debug_print, order_json, coupons_messages = [], callback } = params;

    if (!order_json) return console.log('No order found to print for given order_uuid: ', order_uuid)
    const seat = await order_json?.seat_uuid ? printDependencies?.seats?.find(i => i.seat_uuid === order_json.seat_uuid) : ''
    const section = await order_json?.seat_uuid ? printDependencies?.section_details?.find(i => i.section_uuid === seat?.section_uuid) : ''
    const invoice_setup = printDependencies?.invoice_setup?.find(i => i.brand_uuid === order_json.brand_uuid)
    const browser_print = +invoice_setup?.printer_name === 0 ? true : false;

    PrintInvoice({
      dependencies: {
        invoice_setup,
        order_json,
        dateFormat: printDependencies?.dateFormat,
        seat_name: seat?.seat_name,
        section_name: section?.section_name,
        user_title: printDependencies?.users?.find(i => i.user_uuid === order_json.payment_by_user_uuid),
        paymentMode: printDependencies?.paymentMode,
        itemsDetails: printDependencies?.items,
        kotItemDetails: [].concat.apply([], [].concat.apply([], order_json?.order_kot_details)
          ?.map(kot => kot.kot_items_details?.map(item => ({ ...item, kot: kot.kot }))))
          ?.filter(item => +item?.order_item_status !== 2),
        couponsMessages: coupons_messages
      },
      invoice_details: {
        num: browser_print ? 1 : num,
        ebill,
        debug_print: browser_print ? 'true' : debug_print,
        browser_print,
        customer_mobile: customerInfo?.number,
        bill_total: totalAmount
      },
      callback: callback || (() => setIsInvoiceActive(false))
    })
  }

  // * Cart handlers
  // Handle a new order creation or old order updation
  async function createJson(buttonStatus) {
    if (sessionStorage.getItem('is-payment-popup').toString() === 'true') return console.log(1);
    if (sessionStorage.getItem('popup-state').toString() === 'true') return console.log(2);
    if (!itemCharges?.data?.length) return console.log(3);

    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let store = db.transaction("outlet", "readwrite").objectStore("outlet");
    let outlet = await store.getAll();
    outlet = outlet[0]

    let tx = db.transaction("running_orders", "readwrite");
    store = tx.objectStore("running_orders");
    let runningOrders = await store.getAll();
    const placedOrders = [];

    for (const brandOrder of brand_orders) {

      const { brand_uuid, order_uuid } = await brandOrder;

      let json;
      if (+order_type === 0)
        json = await runningOrders?.find(i => i.seat_uuid === orderProps?.seat_uuid && i.brand_uuid === brand_uuid)
      else {
        json = await runningOrders?.find(i => i.order_uuid === order_uuid && i.brand_uuid === brand_uuid)
        console.log({ json })
      }

      const cartItems = itemCharges?.data?.filter(i => i.brand_uuid === brand_uuid)

      if (json) {
        let time = Date.now();

        json = new_kotOrder({ json, outlet, time, buttonStatus, cartItems });
        json.order_total = json.order_total.toFixed(Number(sessionStorage.getItem("decimal_length")));

        if (json.seat_uuid) {
          let onorder_seats = JSON.parse(localStorage.getItem("onorder_seats")) || null;

          let seat = onorder_seats.find((seat) => seat.seat_uuid === json.seat_uuid)
            ? onorder_seats.find((seat) => seat.seat_uuid === json.seat_uuid)
            : {
              seat_uuid: json.seat_uuid,
              created_at: json.created_at,
              price: json.order_total,
              title: json.local_order_id,
            };
          seat.price = json.order_total;

          let filtered_seats = onorder_seats
            ? onorder_seats.filter(seat => seat.seat_uuid !== json.seat_uuid)
            : [];

          filtered_seats.push(seat);
          localStorage.setItem("onorder_seats", JSON.stringify(filtered_seats));
        }

        tx = db.transaction("running_orders", "readwrite");
        store = tx.objectStore("running_orders");
        json.IsSynched = 0;
        json.modified_at = time;
        await store.put(json);
        placedOrders.push(json)

        FBRunningOrder.SynckData(json.outlet_uuid);
        outlet.invoice_series?.forEach((s) => {
          if (s.user_uuid === localStorage.getItem("user_uuid")) {
            s.last_used_at = Date.now();
            if (+s.next_kot_number < +s.kot_end)
              s.next_kot_number = +s.next_kot_number + 1;
            else s.next_kot_number = +s.kot_start;
          }
        });

        await handleMenuAddUnsyncedFiles(outlet.invoice_series.find(a => a.user_uuid === localStorage.getItem("user_uuid")))

        tx = db.transaction("outlet", "readwrite");
        store = tx.objectStore("outlet");
        await store.put(outlet);

      } else {

        json = await new_order({ outlet, buttonStatus, customerAddress, order_type, order_uuid, brand_uuid, cartItems, customerInfo, remarks: orderRemarks });
        json.order_total = await +json.order_total.toFixed(Number(sessionStorage.getItem("decimal_length")));

        tx = db.transaction("running_orders", "readwrite");
        store = tx.objectStore("running_orders");
        json.IsSynched = 0;
        json.IDENTIFIER = json.order_uuid

        try { await store.add(json) }
        catch (err) {
          json.order_uuid = uuidv4()
          json.IDENTIFIER = await json.order_uuid

          tx = db.transaction("running_orders", "readwrite");
          store = tx.objectStore("running_orders");
          if (+order_type === 0) await store.add(json)
          else return console.log('failed to create order json')
        }

        placedOrders.push(json)
        FBRunningOrder.SynckData(json.outlet_uuid);
        outlet.invoice_series?.forEach((s) => {
          if (s.user_uuid === localStorage.getItem("user_uuid")) {
            s.next_order_number = +s.next_order_number + 1;
            s.last_used_at = Date.now();
            if (+s.next_kot_number < +s.kot_end) s.next_kot_number = +s.next_kot_number + 1;
            else s.next_kot_number = +s.kot_start;
          }
        });

        await handleMenuAddUnsyncedFiles(outlet.invoice_series.find(a => a.user_uuid === localStorage.getItem("user_uuid")))
        tx = db.transaction("outlet", "readwrite");
        store = tx.objectStore("outlet");
        await store.put(outlet);
      }
    }

    if (+order_type === 1 || +order_type === 2) {
      // console.log("localOrderId",sessionStorage.getItem("current-nonseat-order"));
      const unplaced_nonseat_orders = await (await JSON.parse(localStorage.getItem("unplaced-nonseat-order")))?.filter(i => i.order_uuid !== order_uuid) || [];
      localStorage.setItem("unplaced-nonseat-order", JSON.stringify(unplaced_nonseat_orders));

      const nonSeats_ExtendedOrders = await (await JSON.parse(localStorage.getItem("extended-nonseat-order")))?.filter(order => order.order_uuid !== order_uuid) || [];
      localStorage.setItem("extended-nonseat-order", JSON.stringify(nonSeats_ExtendedOrders));
    }

    if (+order_type === 0) {
      let unplaced_orders = await (await JSON.parse(localStorage.getItem("unplaced_orders")))?.filter(order => order.order_uuid !== order_uuid) || [];
      localStorage.setItem("unplaced_orders", JSON.stringify(unplaced_orders));
    }

    // Handle KOT print for orders
    let processedOrderIDs = [];
    const printKOT = order => {
      if (!order) return;
      processedOrderIDs = [...processedOrderIDs, order.order_uuid];
      const callback = () => {
        console.log({ placedOrders })
        if (processedOrderIDs?.length < placedOrders?.length)
          printKOT(placedOrders?.filter(i => !placedOrders.includes(i.order_uuid))?.[0])
      }
      printKotInvoice(+order.order_kot_details[order.order_kot_details.length - 1].kot, order, callback)
    }

    // placedOrders
    if (+buttonStatus === 0 && +sessionStorage.getItem('kot_type') === 2) printKOT(placedOrders?.[0])
    setTimeout(() => Navigate(-1), 80);
  }

  // Update parcel selection and calculation
  const addParcel = item => cartHandler({ item_uuid: item.item_uuid, cart_item_id: item.cart_item_id, action: "parcel" });

  function instructionChange(e) {
    const rows = e.target.value.match(/\n/g);
    if (rows && rows < 3) e.target.rows = 3;
    else if (rows) e.target.rows = rows.length + 1;
    e.target.nextSibling.innerText = `${e.target.value.length}/200`;
  }

  function toggleInstructionField(inst_field_id, action) {
    action === "toggle" && document.getElementById(`${inst_field_id}`).classList.toggle("active");
    action === "remove" && document.getElementById(`${inst_field_id}`).classList.remove("active");
    document.getElementById(`${inst_field_id}`).getElementsByTagName("textarea")[0].focus();
  }

  function saveInstruction(item, inst_field_id) {
    const instruction = document.getElementById(`${inst_field_id}`).getElementsByTagName("textarea")[0].value;
    cartHandler({ item_uuid: item.item_uuid, cart_item_id: item.cart_item_id, action: "instruction", instruction });
    setTimeout(() => { toggleInstructionField(inst_field_id, "remove") }, 300);
  }

  function clearDisCharges(type) {
    Array.from(
      document.getElementById(`${type}-popup`).getElementsByTagName("input")
    )?.forEach((input) => {
      if (input.type !== "radio") input.value = "";
    });
    type === "discount" && setIsDiscountPopupActive(false);
    type === "charge" && setIsChargePopupActive(false);
  }

  // Apply charges and discounts and update order amount --User on Page 1--
  const updateOrderAmount = (obj, order_coupons, order) => {

    order.IsSynched = 0;
    if (order_coupons) order.coupons = order_coupons
    const chargesAndDiscounts = [];
    if (order.charges_and_discounts)
      order.charges_and_discounts?.forEach((element) => chargesAndDiscounts.push(element));

    const response = applyChargesDiscounts({ obj, order });
    order = response.order;
    obj = response.obj;
    chargesAndDiscounts.push(obj);

    order.charges_and_discounts = chargesAndDiscounts;
    if (order.seat_uuid) {
      let onorder_seats = JSON.parse(localStorage.getItem("onorder_seats")) || null;
      let onorder_seat = onorder_seats.find(seat => seat.seat_uuid === order.seat_uuid);
      let filtered_seats = onorder_seats.filter(seat => seat.seat_uuid !== order.seat_uuid);
      onorder_seat.price = order.order_total;
      filtered_seats.push(onorder_seat);
      localStorage.setItem("onorder_seats", JSON.stringify(filtered_seats));
    }
    return order;
  }

  const discountChargesHandler = (type, brands) => {
    // if (!isMouseOut) return;
    // console.log(type, brands, isMouseOut)
    const inputs = document.getElementById(`${type}-popup`).getElementsByTagName("input");

    if (!inputs[1].value) inputs[1].style.border = "1px solid red";
    else inputs[1].style.border = "1px solid black";

    if (!inputs[0].value) return (inputs[0].style.border = "1px solid red");
    else inputs[0].style.border = "1px solid black";

    if (!inputs[1].value) return (inputs[1].style.border = "1px solid red");
    else inputs[1].style.border = "1px solid black";

    let obj = {
      title: inputs[0].value,
    };

    let checkedRadio = null;
    Array.from(inputs)?.forEach((input) => {
      if (input.type === "radio" && input.checked) checkedRadio = input;
    });

    if (checkedRadio.id.includes("amt")) obj.amt = inputs[1].value;
    if (checkedRadio.id.includes("percentage")) obj.percent = inputs[1].value;
    if (inputs[4].value) obj.remarks = inputs[4].value;

    if (type === "discount") {
      obj.type = "D";
      setIsDiscountPopupActive(false);
    } else if (type === "charges") {
      obj.type = "C";
      setIsChargePopupActive(false);
    }

    const updatedOrders = []
    for (const brand_uuid of brands) {
      let order = runningOrder?.find(i => i.brand_uuid === brand_uuid);
      // console.log(order)
      const updatedOrder = updateOrderAmount(obj, null, order);
      updatedOrders?.push(updatedOrder)
    }

    updateOrdersInIDB(updatedOrders)
    const orders = runningOrder?.map(i => updatedOrders?.find(j => j.order_uuid === i.order_uuid) || i)
    setRunningOrder(orders)
    setTotalAmount(orders?.reduce((sum, order) => sum + +order.order_total, 0));

    if (page.includes("/orders")) setForceRenderOrdersPage(uuidv4() + uuidv4());
    setTimeout(() => Navigate(window.location.pathname), 50);
    Array.from(document.getElementById(`${type}-popup`).getElementsByTagName("input"))?.forEach((input) => {
      if (input.type !== "radio") input.value = "";
    });
  }

  const updateOrdersInIDB = async collection => {
    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = db.transaction("running_orders", "readwrite").objectStore("running_orders");
    for (const order of collection) {
      await tx.put(order)
    }
    refreshDashboard && refreshDashboard()
  }

  const clearInstruction = (item) => cartHandler({ item_uuid: item.item_uuid, cart_item_id: item.cart_item_id, action: "instruction", instruction: null });

  function paymentPopupHandler(orderID) {

    let isOrderPending;
    if (page.includes("/page1") || (page.includes("/page2") && +order_type === 0)) {
      isOrderPending = (JSON.parse(localStorage.getItem("unplaced_orders")))?.some(order => order.order_uuid === order_uuid);
    }
    else if (page.includes("/page2") && (+order_type === 1 || +order_type === 2)) {
      let extendedOrders = JSON.parse(localStorage.getItem("extended-nonseat-order")) || [];
      isOrderPending = extendedOrders.some(order => order.order_uuid === order_uuid);

      if (!isOrderPending) {
        let unplacedOrders = JSON.parse(localStorage.getItem("unplaced-nonseat-order")) || [];
        isOrderPending = unplacedOrders.some(order => order.order_uuid === order_uuid);
      }
    }

    if (isOrderPending) {
      clearInterval(sessionStorage.getItem("notification-warning-timeout"));
      document.querySelector(".notification-message").innerText = "Action pending for some items";
      document.querySelector(".notification-container").classList.add("active-red");

      const timeoutId = setTimeout(() => document.querySelector(".notification-container").classList.remove("active-red"), 2000);
      sessionStorage.setItem("notification-warning-timeout", timeoutId);
    }

    if (!isOrderPending) {
      sessionStorage.setItem("is-payment-popup", true);
      const amount = orderID ? +runningOrder?.find(i => i.order_uuid === orderID)?.order_total : page.includes("/page2") ? page2Total : totalAmount
      const order_uuids = orderID ? [orderID] : brand_orders?.map(i => i.order_uuid)
      setPaymentOptionOpen({ status: true, amount, orderProps: { ...orderProps, order_uuids, brand_orders } });
    }
  }

  const showWarning = message => warn({ message: message || "First, place an order." })

  function setItemChargesFunction() {
    // console.log(itemChargesValueRef.current);
    setItemCharges({ data: itemChargesValueRef.current })
  }

  const [showAddresses, setShowAddresses] = useState(null);
  const [customerAddress, setCustomerAddress] = useState("");
  const [selectedCustomerDetails, setSelectedCustomerDetails] = useState({ status: null, data: {} });

  const invokeAddressBlur = useRef(false);
  const invokeCustomerDetailsBlur = useRef(false);
  const addressTextAreaRef = useRef(null);

  useEffect(() => {
    if (customerAddress && addressTextAreaRef.current?.style)
      addressTextAreaRef.current.style.height = `${((customerAddress.address?.split("\n")?.length + 1) * 20) + 20}px`
  }, [customerAddress])

  const [couponPopupState, setCouponPopupState] = useState(null)

  const couponCodeHandler = async brands => {

    // console.log('coupon code : ', couponPopupState?.code)
    if (couponPopupState?.code?.length !== 8) return showWarning('Coupon code invalid!')

    let db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    let tx = db.transaction("coupon", "readonly").objectStore("coupon");
    let coupon = await tx.getAll();
    coupon = await coupon.find(i => i.coupon_code === couponPopupState.code)
    if (!coupon) return showWarning('Coupon code invalid!')

    tx = db.transaction("scheme", "readonly").objectStore("scheme");
    let scheme = await tx.get(coupon.scheme_uuid)
    if (!scheme || +scheme?.scheme_status !== 1) return showWarning('No active scheme found for provided coupon!')
    let response;
    try {
      response = await axios({
        method: "post",
        // url: "http://localhost:5000/coupon/validate-coupon-code",
        url: "https://api.myfooddo.com/coupon/validate-coupon-code",
        data: {
          coupon_code: couponPopupState?.code,
          customer_mobile: customerInfo?.number,
          outlet_uuid: localStorage.getItem('outlet_uuid')
        }
      })
    }
    catch (err) {
      console.log({ err })
      if (err?.response?.data?.message) return showWarning(err?.response?.data?.message)
      else if (err.status !== 200) return showWarning('Coupon Validation Failed')
    }

    if (!response) return

    const current_person_index = +response?.data?.current_person_index
    const updatedOrders = []

    await db.transaction("coupon", "readwrite").objectStore("coupon").put({
      ...coupon, persons_details: response?.data?.persons_details, current_person_index
    });

    for (const brand_uuid of brands) {
      let order = runningOrder?.find(i => i.brand_uuid === brand_uuid);

      const order_coupons = order?.coupons || []
      const person = current_person_index === 2 ? scheme.second_person : scheme?.other_persons?.find(i => +i.person_index === current_person_index)
      const order_coupon = {
        coupon_code: coupon.coupon_code,
        scheme_uuid: coupon.scheme_uuid,
        current_person_index,
        applied: 0,
      }

      if (+person.min_bill_amt) order_coupon.min_bill = person.min_bill_amt
      if (+person.max_limit) order_coupon.max_discount = person.max_limit

      let discountedAmount;
      if (person.discount_type === 'P') discountedAmount = (+order?.order_total * +person.value) / 100
      else discountedAmount = +person.value;

      if (
        person.paymode_uuid === 'D'
        && (!order_coupon.min_bill || +order?.order_total > +order_coupon.min_bill)
      ) {

        const discount = {}
        discount.type = "D";
        discount.title = await coupon.coupon_code;

        if (+order_coupon.max_discount && discountedAmount > +order_coupon.max_discount)
          discount.amt = +order_coupon.max_discount
        else
          if (person.discount_type === "A") discount.amt = discountedAmount;
          else if (person.discount_type === "P") discount.percent = +person.value;

        await order_coupons.push({ ...order_coupon, applied: 1 })
        order = updateOrderAmount(discount, order_coupons, order)
      }
      else {
        order_coupons.push({ ...order_coupon })
        order.coupons = order_coupons
      }
      updatedOrders?.push(order)
      tx = db.transaction("running_orders", "readwrite").objectStore("running_orders");
      tx.put(order)
    }

    const orders = runningOrder?.map(i => updatedOrders?.find(j => j.order_uuid === i.order_uuid) || i)
    setRunningOrder(orders)
    setTotalAmount(orders?.reduce((sum, order) => sum + +order.order_total, 0));

    setIsDiscountPopupActive(false);
    setCouponPopupState(null);
  }

  const [orderDetailPopup, setOrderDetailPopup] = useState({ status: false, order_uuid: null })
  const [isBrandPopupOpen, setIsBrandPopupOpen] = useState(false)

  const onBrandSelect = brand_uuid => {
    setOrderDetailPopup({ order_uuid: runningOrder?.find(i => i.brand_uuid === brand_uuid)?.order_uuid, status: true })
    setIsBrandPopupOpen(false)
  }

  const onCouponBtnClick = () => {
    if (!navigator.onLine) return showWarning('Internet connection is required to apply coupon')
    else if (!customerInfo.number) showWarning('Enter customer mobile number first!')
    else setCouponPopupState(true)
  }

  return (
    <>
      {isBrandPopupOpen &&
        <BrandSelectionPopUp
          options={runningOrder?.map(i => i.brand_uuid)}
          onSelect={onBrandSelect}
          close={() => setIsBrandPopupOpen(false)}
        />
      }
      {orderDetailPopup?.status && (
        <OrderSummaryTable
          value={runningOrder?.[1] ? runningOrder?.find(i => i.order_uuid === orderDetailPopup?.order_uuid) : runningOrder?.[0]}
          setOrderProps={setOrderProps}
          setIsOrdersTablePopUpOpen={() => {
            setOrderDetailPopup({ status: false })
            if (page?.includes('/page1')) refreshDashboard()
            else if (page?.includes('/orders')) setForceRenderOrdersPage(uuidv4() + uuidv4())
          }}
        />
      )}
      <div
        ref={itemChargesHandlerRef}
        onClick={setItemChargesFunction}
        style={{ display: "none" }}
      />
      <div
        className={`info ${page.includes("/page1") ||
          (page.includes("/page2") && document.querySelector(".brands-tabs"))
          ? "touchTop"
          : ""
          }`}
      >
        <div className="info-container">
          <div className="inputs">
            <input
              type="text"
              id="contact-number"
              value={customerInfo.number}
              onChange={(e) => {
                if (customerInfo.number === "+91-" && e.target.value.length < 4) {
                  e.target.value = "";
                  setCustomerInfo({ ...customerInfo, number: "" });
                  storeOrdersContacts("", 1)
                  return e.preventDefault();
                }

                var patt = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g;
                if (!e.target.value || patt.test(e.target.value)) {
                  setCustomerInfo({ ...customerInfo, number: "+91-" + e.target.value.replaceAll("+91-", "") });
                  showSuggestions(e);
                  storeOrdersContacts("+91-" + e.target.value.replaceAll("+91-", ""), 1)
                  sessionStorage.setItem('customer-updated-info', JSON.stringify({
                    ...customerInfo,
                    number: "+91-" + e.target.value.replaceAll("+91-", ""),
                    order_uuid
                  }))
                }
              }}
              onBlur={() => {
                if (cursorOverSuggestionRef.current === "visible") return;
                updateOrderCustomer()
                document.getElementById("suggestions-div").style.display = "none";
              }}
              placeholder="Customer Mobile"
            />
            <input
              type="text"
              id="contact-name"
              value={customerInfo.name}
              onChange={(e) => {
                setCustomerInfo({ ...customerInfo, name: e.target.value });
                showSuggestions(e);
                storeOrdersContacts(e.target.value, 2)
                sessionStorage.setItem('customer-updated-info', JSON.stringify({
                  ...customerInfo,
                  name: e.target.value,
                  order_uuid
                }))
              }}
              onBlur={() => {
                if (cursorOverSuggestionRef.current === null || cursorOverSuggestionRef.current !== "visible") {
                  if (page.includes("/page2")) {
                    setTimeout(() => updateContact(), 500)
                  }
                  else {
                    updateOrderCustomer()
                    document.getElementById("suggestions-div").style.display = "none";
                  }
                }
              }}
              placeholder="Customer Name"
            />
            <div
              id="dropdown-toggler"
              className={selectedCustomerDetails.status && "active"}
              onClick={e => {
                if (customerInfo.number)
                  setSelectedCustomerDetails({
                    status: !selectedCustomerDetails?.status,
                    data: customersDetails?.find(c => c.mobile === customerInfo?.number)
                  })
                else
                  showWarning("Enter Mobile Number")
              }}
              onMouseOver={e => invokeCustomerDetailsBlur.current = true}
              onMouseLeave={e => invokeCustomerDetailsBlur.current = false}
            >
              <ArrowDropDown />
            </div>
          </div>
          {selectedCustomerDetails.status &&
            <button
              id="customer-details-dropdown"
              className={page.includes("/page1") && "page1"}
              onBlur={e => {
                if (invokeCustomerDetailsBlur.current === false) {
                  setSelectedCustomerDetails({ status: false });
                  updateCustomerData(grabIDBCustomersData);
                }
              }}
              onMouseOver={e => invokeCustomerDetailsBlur.current = true}
              onMouseLeave={e => invokeCustomerDetailsBlur.current = false}
              autoFocus
            >
              <div id="visits">{selectedCustomerDetails?.visits || 0} visits</div>
              <label htmlFor="customer_address">Customer Address</label>
              <div>
                <textarea
                  id="customer_address"
                  ref={addressTextAreaRef}
                  rows={customerAddress?.split("\n")?.length + 1 || 2}
                  placeholder="Customer Address"
                  onFocus={e => {
                    setShowAddresses(true);
                    localStorage.setItem("preventKeyboard", true);
                  }}
                  onBlur={e => {
                    if (invokeAddressBlur.current === false) {
                      setShowAddresses(false);
                      localStorage.removeItem("preventKeyboard");
                    }
                  }}
                  onChange={e => {
                    setCustomerAddress(e.target.value);
                    e.target.rows = customerAddress?.split("\n")?.length + 1;
                    storeCustomersData({ address: e.target.value, id: selectedCustomerDetails?.data?.mobile }, 1);
                  }}
                  value={customerAddress || ""}
                />
                <SquareFoot className="resize" />
              </div>
              <label htmlFor="order_remarks">Remarks</label>
              <div>
                <input
                  id="order_remarks"
                  placeholder="Order Remarks"
                  onFocus={e => localStorage.setItem("preventKeyboard", true)}
                  onBlur={e => {
                    localStorage.removeItem("preventKeyboard");
                    if (page?.includes("/page1"))
                      updateOrdersInIDB(runningOrder?.map(i => {
                        if (e.target.value?.length === 0) delete i.remarks
                        else i.remarks = e.target.value
                        return i
                      }))
                  }}
                  onChange={e => setOrderRemarks(e.target.value)}
                  value={orderRemarks || ""}
                />
              </div>
              {showAddresses &&
                <ul
                  id="addresses-list"
                  onMouseOver={e => invokeAddressBlur.current = true}
                  onMouseLeave={e => invokeAddressBlur.current = false}
                >
                  <li
                    onClick={e => {
                      setCustomerAddress(selectedCustomerDetails?.data?.address);
                      setShowAddresses(false);
                    }}
                  >
                    {selectedCustomerDetails?.data?.address}
                  </li>
                </ul>
              }
            </button>}
          <div
            id="suggestions-div"
            style={{ display: "none" }}
            ref={cursorOverSuggestionRef}
          >
            {domState}
          </div>
          <div className="name">
            <h3>
              {+order_type === 0 && orderProps?.seat_uuid ? (
                `${seatsState?.find(i => i.seat_uuid === orderProps?.seat_uuid)?.seat_name || ''}
                -${sectionsState?.find(i => i.section_uuid === seatsState?.find(i => i.seat_uuid === orderProps?.seat_uuid)?.seat_uuid)?.section_name || ''}`
              ) : (+order_type === 1 || +order_type === 2) ? (
                `${sessionStorage.getItem("current-nonseat-type") || "TakeAway"} -
                 ${runningOrder?.map(i => i.local_order_id)?.join(', ') || ''}`
              ) : ''}
              <span id="total-amount">: Rs. {Math.round(totalAmount)}</span>
            </h3>
            {(page.includes("/orders") || page.includes("/page1")) ?
              <button
                className="edit"
                onClick={() => {
                  if (!runningOrder?.[0]) return showWarning()
                  else if (runningOrder?.reduce((brands, order) =>
                    brands?.includes(order.brand_uuid) ? brands : brands?.concat([order.brand_uuid]), []
                  )?.length > 1) setIsBrandPopupOpen(true)
                  else setOrderDetailPopup({ status: true })
                }}
              >Details</button>
              : ''
            }
          </div>
          <div className="description-container">
            <table className="description">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {(runningOrder?.[0] && itemsList && (page.includes("/page1") || page.includes("/orders"))) ?
                  runningOrder?.map(order => (
                    <>
                      {runningOrder?.length > 1 ? <tr className="order-brand-name">{menusCollection?.brands?.find(i => i.brand_uuid === order.brand_uuid)?.brand_name}</tr> : ''}
                      {order.order_kot_details?.map((kot_order) =>
                        kot_order.kot_items_details?.map((item) => {
                          const color = +item.order_item_status === 2 ? "red" : +item.order_item_status === 1 ? "green" : "black";
                          item.item_name = itemsList.find(i => i.item_uuid === item.item_uuid)?.item_name;

                          return (
                            <tr key={Math.random()} style={{ color: color }}>
                              <td>{item.item_name}</td>
                              <td>{item.order_item_qty}</td>
                              <td>
                                Rs.{(
                                  +item.order_item_unit_price +
                                  (item.addon_details?.reduce((sum, a) => sum + +a.price, 0) || 0) +
                                  (item.multi_details?.reduce((sum, a) => sum + +a.price, 0) || 0)
                                ) * +item.order_item_qty}
                              </td>
                              <td>
                                <PencilAltIcon
                                  style={{
                                    height: "20px",
                                    color: item.order_item_instruction ? "red" : "black",
                                  }}
                                />
                                <ShoppingBagIcon
                                  style={{
                                    color:
                                      item.parcel === "Y"
                                        ? "green"
                                        : item.parcel === "N"
                                          ? "black"
                                          : "#0080008a",
                                    height: "20px",
                                  }}
                                />
                              </td>
                            </tr>
                          );
                        })
                      )}
                      {runningOrder?.length > 1 ?
                        <tr>
                          <td><hr /></td>
                          <td><hr /></td>
                          <td><hr /></td>
                          <td style={{ display: 'table-cell' }}><hr />  </td>
                        </tr> : ''}
                    </>
                  )
                  ) : (itemCharges && itemCharges?.data?.length > 0) ?
                    itemCharges.data?.map((element, index) => {
                      return (
                        <tr key={Math.random()}>
                          <td>{element.item_name}</td>
                          <td><QuantityEditable quantity={element.order_item_qty} item={element} /></td>
                          <td>Rs.{+element.order_item_taxable_value}</td>
                          <td>
                            <div
                              style={{
                                display: "inline-block",
                                position: "relative",
                              }}
                            // onBlur={() => saveInstruction(element, `instruction-${element.cart_item_id}`)}
                            >
                              <PencilAltIcon
                                style={{
                                  height: "20px",
                                  color: element.order_item_instruction ? "red" : "black",
                                }}
                                onClick={() => toggleInstructionField(`instruction-${element.cart_item_id}`, "toggle")}
                              />
                              <div
                                id={`instruction-${element.cart_item_id}`}
                                className={`item-edit-popup ${index <= 1 ? "bottom" : "top"}`}
                              >
                                <textarea
                                  maxLength="200"
                                  rows={3}
                                  placeholder="Instructions.."
                                  defaultValue={element.order_item_instruction || ""}
                                  onChange={(e) => instructionChange(e)}
                                />
                                <span
                                  id="instruction_length"
                                  style={{
                                    color: "grey",
                                    padding: "2px 5px",
                                    fontSize: "13px",
                                  }}
                                >
                                  0/200
                                </span>
                                <div className="item-edit-popup-actions">
                                  <button
                                    className="red"
                                    onClick={() => clearInstruction(element, `instruction-${element.cart_item_id}`)}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    style={{ backgroundColor: "#44cd4a" }}
                                    onClick={() => saveInstruction(element, `instruction-${element.cart_item_id}`)}
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            </div>
                            <ShoppingBagIcon
                              onClick={() => addParcel(element)}
                              style={{
                                color: element.parcel === "Y" ? "#44cd4a" : element.parcel === "N" ? "black" : "#0080008a",
                                height: "20px",
                              }}
                            />
                          </td>
                        </tr>
                      );
                    }) : ''}
              </tbody>
            </table>
          </div>
        </div>

        <div className="info-actions">
          {page.includes("/page2") &&
            <>
              {<>
                <div
                  className="button-group col-2"
                  onBlur={() => setTimeout(() => setIsChefPopupActive(false), 300)}
                >
                  <button onClick={(e) => createJson(0)} id="save&kot-btn">
                    Save & KOT
                  </button>
                  <button
                    className={`menu ${isChefPopupActive ? "active" : ""}`}
                    onClick={(e) => setPaymentOptionOpen({
                      status: true,
                      amount: page2Total,
                      saveNpayment: true,
                      kotOption: true,
                      orderProps: { ...orderProps, order_uuids: brand_orders?.map(i => i.order_uuid), brand_orders }
                    })}
                    id="save&kot-payment-btn"
                  >
                    Confirm & Payment
                  </button>
                  <button onClick={() => setIsChefPopupActive(!isChefPopupActive)}>
                    <ChevronUpIcon style={{ color: "white", height: "20px" }} />
                  </button>
                </div>
                <div
                  className="button-group col-2"
                  onBlur={() => setTimeout(() => setIsDirectAddPopupActive(false), 300)}
                >
                  <button onClick={(e) => createJson(1)} id="save-btn">
                    Save
                  </button>
                  <button
                    className={`menu ${isDirectAddPopupActive ? "active" : ""}`}
                    onClick={(e) => setPaymentOptionOpen({
                      status: true,
                      amount: page2Total,
                      saveNpayment: true,
                      orderProps: { ...orderProps, order_uuids: brand_orders?.map(i => i.order_uuid), brand_orders }
                    })}
                    id="save-payment-btn"
                  >
                    Confirm & Payment
                  </button>
                  <button
                    onClick={() =>
                      setIsDirectAddPopupActive(!isDirectAddPopupActive)
                    }
                  >
                    <ChevronUpIcon style={{ color: "white", height: "20px" }} />
                  </button>
                </div>

                {runningOrder?.filter(i => +i.payment_status !== 1)?.length > 0 || !runningOrder?.[0] ? (
                  <div className="pay-btns col-4">
                    <button
                      onClick={() => runningOrder ? paymentPopupHandler() : showWarning()}
                      id="payment-btn"
                      className="col-4"
                      style={{ backgroundColor: "#44cd4a", width: '100%' }}
                    >
                      Pay Rs.{page2Total}
                    </button>
                    {runningOrder?.[1] && <BrandOrdersToPay paymentPopupHandler={paymentPopupHandler} runningOrder={runningOrder} brands={menusCollection?.brands} />}
                  </div>
                ) : (
                  <button
                    id="payment-btn"
                    style={{ background: "black" }}
                    className="col-4"
                    onClick={() => showWarning("Already Paid")}
                  >
                    Paid Rs.{page2Total}
                  </button>
                )}
              </>}
            </>
          }

          {page.includes("/page1") || page.includes("/orders") ? (
            <>
              {/* Charges */}
              <DiscountChargesPopup
                key={'Charges'}
                brands={menusCollection?.brands?.[0] ? runningOrder?.map(o => menusCollection?.brands?.find(b => b.brand_uuid === o.brand_uuid)) : []}
                toggleClick={() => runningOrder ? setIsChargePopupActive(!isChargePopupActive) : showWarning()}
                title={'Charges'}
                onSubmit={(title, brands = []) => discountChargesHandler(title, brands)}
                mouseHandler={boolean => ''}
                containerStyle={{ opacity: isChargePopupActive ? '1' : '0', pointerEvents: isChargePopupActive ? 'all' : 'none' }}
                clear={title => clearDisCharges(title)}
              />

              {/* Discounts */}
              <DiscountChargesPopup
                key={'Discount'}
                brands={menusCollection?.brands?.[0] ? runningOrder?.map(o => menusCollection?.brands?.find(b => b.brand_uuid === o.brand_uuid)) : []}
                toggleClick={() => runningOrder ? setIsDiscountPopupActive(!isDiscountPopupActive) : showWarning()}
                title={'Discount'}
                onSubmit={(title, brands = []) => discountChargesHandler(title, brands)}
                mouseHandler={boolean => ''}
                containerStyle={{ left: 'calc(-100% - 5px)', opacity: isDiscountPopupActive ? '1' : '0', pointerEvents: isDiscountPopupActive ? 'all' : 'none' }}
                clear={title => clearDisCharges(title)}
                onCouponBtnClick={onCouponBtnClick}
                couponCodeHandler={couponCodeHandler}
                couponPopupState={couponPopupState}
                setCouponPopupState={setCouponPopupState}
              />

              <div className="button-group col-1">
                <button
                  onClick={() => runningOrder ? setIsInvoiceActive(!isInvoiceActive) : showWarning()}
                  onBlur={() => setTimeout(() => setIsInvoiceActive(false), 200)}
                >
                  Invoice
                </button>
                <div className={`menu KOT ${isInvoiceActive ? "active" : ""}`}>
                  <button
                    onClick={() => invoicePrintLoop(1, false, "true")}
                    style={{ cursor: "pointer" }}
                  >
                    Print
                  </button>
                  <button
                    onClick={() => invoicePrintLoop(1)}
                    style={{ cursor: "pointer" }}
                  >
                    1
                  </button>
                  <button
                    onClick={() => invoicePrintLoop(2)}
                    style={{ cursor: "pointer" }}
                  >
                    2
                  </button>
                  <button
                    onClick={() => invoicePrintLoop(1, true)}
                    style={{ cursor: "pointer" }}
                  >
                    eBill
                  </button>
                </div>
              </div>

              <div className="button-group col-1">
                <button
                  onClick={() => runningOrder ? setIsKOTPopupActive(!isKOTPopupActive) : showWarning()}
                  onBlur={() => setTimeout(() => setIsKOTPopupActive(false), 1000)}
                >
                  KOT
                </button>
                <div className={`menu KOT ${isKOTPopupActive ? "active" : ""}`}>
                  {runningOrder?.map(order =>
                    order?.order_kot_details?.map(kot => (
                      <button
                        type="button"
                        onClick={() => printKotInvoice(+kot?.kot, order)}
                        style={{ cursor: "pointer" }}
                      >
                        {kot?.kot}
                      </button>
                    ))
                  )}
                </div>
              </div>

              {runningOrder?.filter(i => +i.payment_status !== 1)?.length > 0 || !runningOrder?.[0] ? (
                <>
                  <div className="pay-btns col-4">
                    <button
                      onClick={() => runningOrder ? paymentPopupHandler() : showWarning()}
                      id="payment-btn"
                      className="col-4"
                      style={{ backgroundColor: "#44cd4a", width: '100%' }}
                    >
                      Pay Rs.{totalAmount}
                    </button>
                    {runningOrder?.[1] && <BrandOrdersToPay paymentPopupHandler={paymentPopupHandler} runningOrder={runningOrder} brands={menusCollection?.brands} />}
                  </div>
                </>
              ) : (
                <button
                  id="payment-btn"
                  style={{ background: "black" }}
                  className="col-4"
                  onClick={() => showWarning("Already Paid")}
                >
                  Paid Rs.{totalAmount}
                </button>
              )}
            </>
          ) : (
            ""
          )}
        </div>
      </div>
      {
        isPaymentOptionOpen.status && (
          <PaymentPopup
            isPaymentOptionOpen={isPaymentOptionOpen} setPaymentOptionOpen={setPaymentOptionOpen}
            customerInfo={customerInfo} setCustomerInfo={setCustomerInfo}
            new_order={props => new_order({ ...props, customerAddress, order_type, cartItems: itemCharges?.data?.filter(i => i.brand_uuid === props.brand_uuid), customerInfo })}
            new_kotOrder={props => new_kotOrder({ ...props, cartItems: itemCharges?.data?.filter(i => i.brand_uuid === props.brand_uuid) })}
            handleInvoicePrint={handleInvoicePrint} printKotInvoice={printKotInvoice}
            orderProps={orderProps}
          />
        )
      }
    </>
  );
};

const DiscountChargesPopup = ({
  toggleClick,
  title,
  onSubmit,
  mouseHandler,
  containerStyle,
  clear,
  brands,
  onCouponBtnClick,
  couponCodeHandler,
  couponPopupState, setCouponPopupState
}) => {

  const [brandSelection, setBrandSelection] = useState([])
  useEffect(() => {
    setBrandSelection(brands?.map(({ brand_uuid, brand_name }) => ({ value: brand_uuid, label: brand_name })) || []);
  }, [brands])

  return (
    <div className="button-group col-1">
      <button onClick={toggleClick}>{title}</button>
      <div
        tabIndex="0"
        // onBlur={() => onSubmit(title?.toLowerCase())}
        // onMouseEnter={() => mouseHandler(false)}
        // onMouseLeave={() => mouseHandler(true)}
        style={{ ...containerStyle, width: 'auto' }}
        id={`${title?.toLowerCase()}-popup`}
        className='info-action-popup'
      >

        <div className='sub-header'>
          <h1 style={{ textAlign: 'center' }}>{title}</h1>
        </div>

        <div
          className="info-action-popup-content"
          onMouseEnter={() => mouseHandler(false)}
        >
          {brands?.length > 1 && <MultiSelectDropDown
            label={'Select Brands'}
            onSelect={setBrandSelection}
            selected={brandSelection}
            options={brands?.map(({ brand_uuid, brand_name }) => ({ value: brand_uuid, label: brand_name }))}
            styles={{ container: { position: 'unset', color: 'black' }, selectBtn: { width: 'auto' } }}
          />}
          <input
            type="text"
            placeholder="Title (Displayed)"
            id={`${title.toLowerCase()}-title`}
          />
          <input
            type="number"
            placeholder="Value"
            id={`${title.toLowerCase()}-value`}
          />
          <div className="info-action-popup-radio-inputs">
            <div className="radio-input">
              <input
                type="radio"
                name={`${title.toLowerCase()}-radio`}
                id={`${title.toLowerCase()}-amt`}
              />
              <label htmlFor={`${title.toLowerCase()}-amt`}>Amt</label>
            </div>
            <div className="radio-input">
              <input
                type="radio"
                name={`${title.toLowerCase()}-radio`}
                id={`${title.toLowerCase()}-percentage`}
                defaultChecked
              />
              <label htmlFor={`${title.toLowerCase()}-percentage`}>Percentage</label>
            </div>
          </div>
          <input
            type="text"
            placeholder="Remarks (Not Displayed)"
            id={`${title.toLowerCase()}-remarks`}
            style={{ marginTop: 10 }}
          />
        </div>

        <div className="info-action-popup-actions">
          {title?.toLowerCase() === 'discount' &&
            <button
              style={{ backgroundColor: "blue" }}
              // onMouseEnter={() => mouseHandler(false)}
              onClick={onCouponBtnClick}
            >
              Coupon
            </button>}
          <button
            className="red"
            // onMouseEnter={() => mouseHandler(false)}
            onClick={() => clear(title?.toLowerCase())}
          >
            Clear
          </button>
          <button
            style={{ backgroundColor: "green" }}
            // onMouseEnter={() => mouseHandler(true)}
            onClick={() => onSubmit(title?.toLowerCase(), brandSelection?.map(i => i.value))}
          >
            Submit
          </button>
        </div>

        {couponPopupState ? <div className="coupon-input-container">
          <input type="text" placeholder="COUPON-CODE" onChange={e => setCouponPopupState({ active: true, code: e.target.value?.toUpperCase() })} value={couponPopupState?.code || ""} maxLength={8} />
          <div className="coupon-btns-container">
            <button className="coupon-cancel" onClick={e => setCouponPopupState(false)}>Cancel</button>
            <button className="coupon-save" onClick={e => couponCodeHandler(brandSelection?.map(i => i.value))}>Save</button>
          </div>
        </div> : ''}
      </div>
    </div>
  )
}

const BrandOrdersToPay = ({ runningOrder, paymentPopupHandler, brands }) => {

  const [paymentOrderPopUp, setPaymentOrderPopUp] = useState({ status: false, order_uuid: null })
  return (
    <>
      <button
        style={{ padding: '8px', background: '#45cc4c' }}
        onClick={e => setPaymentOrderPopUp(i => ({ ...i, status: !i.status }))}
      >
        <ChevronUpIcon style={{ color: "white", height: "19px", width: '30px' }} />
      </button>
      {paymentOrderPopUp?.status &&
        <div className='order-brand-menu'>
          {runningOrder?.map((i) => (
            <button
              type="button"
              style={{ cursor: "pointer", background: '#45cc4c' }}
              onClick={e => paymentPopupHandler(i?.order_uuid)}
            >
              {brands?.find(j => j.brand_uuid === i?.brand_uuid)?.brand_name} Rs.{i?.order_total}
            </button>
          ))}
        </div>
      }
    </>
  )
}

export default Info;